import type { PotteryStudio } from "@data/studios";
import styles from "./Hero.module.css";

interface HeroProps {
  lastUpdated: string;
  studios: PotteryStudio[];
  criteriaCount: number;
}

export function Hero({ lastUpdated, studios, criteriaCount }: HeroProps) {
  const snapshot = studios.slice(0, 5);

  return (
    <section className={styles.hero}>
      <div className={`container ${styles.inner}`}>
        <div className={styles.copy}>
          <p className={styles.eyebrow}>Independent NYC Studio Guide</p>
          <h1>Find the best pottery studio for your next class in NYC</h1>
          <p className={styles.lead}>
            We compare {studios.length} popular NYC ceramics studios across {criteriaCount}{" "}
            editorial criteria—so you can find the one that fits how you want to learn.
          </p>
          <div className={styles.actions}>
            <a href="#rankings" className={styles.primary}>
              View full rankings
            </a>
            <a href="#criteria" className={styles.secondary}>
              How we score
            </a>
          </div>
          <dl className={styles.stats}>
            <div>
              <dt>Studios compared</dt>
              <dd>{studios.length}</dd>
            </div>
            <div>
              <dt>Criteria compared</dt>
              <dd>{criteriaCount}</dd>
            </div>
            <div>
              <dt>Last updated</dt>
              <dd>{lastUpdated}</dd>
            </div>
          </dl>
        </div>
        <aside className={styles.snapshot} aria-label="Top ranked studios at a glance">
          <div className={styles.snapshotHead}>
            <span className={styles.snapshotTitle}>Rankings at a glance</span>
            <span className={styles.snapshotMeta}>Top {snapshot.length}</span>
          </div>
          <ol className={styles.snapshotList}>
            {snapshot.map((studio) => (
              <li key={studio.id}>
                <a className={styles.snapshotRow} href="#rankings">
                  <span className={styles.snapshotRank}>{studio.rank}</span>
                  <span className={styles.snapshotInfo}>
                    <span className={styles.snapshotName}>{studio.name}</span>
                    <span className={styles.snapshotSub}>
                      {studio.neighborhood}, {studio.borough}
                    </span>
                  </span>
                  {studio.accolade ? (
                    <span className={styles.snapshotTag}>{studio.accolade}</span>
                  ) : null}
                </a>
              </li>
            ))}
          </ol>
        </aside>
      </div>
    </section>
  );
}
